import React, { Component } from "react";
import { Navbar } from 'react-bootstrap';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { withRouter} from 'react-router-dom';

import { isEmail } from "validator";

import './Login.scss';

import { getDevelopmentByCode, resetPassword } from '../../../api/Api.js';
import eye1 from '../../../assets/img/icons/ico_show_password.png';
import eye2 from '../../../assets/img/icons/ico_hide_password.png';


const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Campo requerido
      </div>
    );
  }
};

const DEVELOPMENT_CODE = process.env.REACT_APP_DEVELOPMENT_CODE;

class Recover extends Component {
  constructor(props) {
    super(props);
    this.handleRecover = this.handleRecover.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      development_id: null,
      development: null,
      password: "",
      loading: false,
      message: "",
      showPassword: false,
    };
  }

  componentDidMount() {
    getDevelopmentByCode(DEVELOPMENT_CODE).then(
      (res) => {
  
        this.setState({
          development_id: res.development_id,
          development: res,
        });
        
      }
    );  
  
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  handleRecover = (e) => {
    const{ password }  = this.state;
    e.preventDefault();

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();

    let token = this.props.match.params.token;

    if (this.checkBtn.context._errors.length === 0) {
      resetPassword({ password, token }).then(
        (res) => {
          if(res && res.success){
            this.setState({
              loading: false,
            });

            this.props.history.push("/admin/login");
            window.location.reload();

          }else{
            this.setState({
              loading: false,
              message: 'No se pudo restablecer la contraseña. Intenta nuevamente.'
            });
          }
        }
      );
    } else {
      this.setState({
        loading: false
      });
    }
  }

  renderHeader = () => {
    return (
      <Navbar id="main_nav" bg="dark" expand="lg">
        
          {this.state.development && this.state.development.url_image &&
            <Navbar.Brand href="/admin">
              <img src={this.state.development.url_image} alt={this.state.development.name} height="60" />
            </Navbar.Brand>
          }
          
      </Navbar>
    )
  }
  
  renderForm = () => {
    return (
    <Form
        onSubmit={this.handleRecover}
        ref={c => {
        this.form = c;
        }}
    >
        <div className="form-group" style={{ textAlign: 'center' }}>
        Restablecer Contraseña
        </div>
        
        <div className="form-group password-container">
            <label htmlFor="password">Nueva Contraseña</label>
            <Input
                type={this.state.showPassword ? 'text' : 'password'}
                className="form-control"
                name="password"
                value={this.state.password}
                onChange={this.onChangePassword}
                validations={[required]}
            />
            
            <a className="password-eye-section" onClick={this.togglePassword}>
                { this.state.showPassword &&
                    <img src={eye2} />
                }
                { !this.state.showPassword &&
                    <img src={eye1} />
                }
            </a>
        </div>

        <div className="form-group">
        <button
            className="btn btn-primary btn-block"
            disabled={this.state.loading}
        >
            {this.state.loading && (
            <span className="spinner-border spinner-border-sm"></span>
            )}
            <span>Aceptar</span>
        </button>
        </div>

        {this.state.message && (
        <div className="form-group">
            <div className="alert alert-danger" role="alert">
            {this.state.message}
            </div>
        </div>
        )}
        <CheckButton
        style={{ display: "none" }}
        ref={c => {
            this.checkBtn = c;
        }}
        />
    </Form>
    );
    
  }

  togglePassword = (e) => {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword,
    });
  }

  render() {
    return (
      <div className="containter main-containter">
        { this.renderHeader() }
        <div className="col-md-12">
          <div className="card card-container">
            <img
              src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
              alt="profile-img"
              className="profile-img-card"
            />

            { this.renderForm() }

          </div>
        </div>
      </div>
    );
  }

}

export default withRouter(Recover);